// Vendor
import { NgModule } from "@angular/core";

// Modules
import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IconsModule } from "../icons/icons.module";

// Components
import { StepsComponent } from "./steps/steps.component";
import { StepComponent } from "./step/step.component";
import { NavigationComponent } from "./navigation/navigation.component";
import { NavigationCostsComponent } from "./navigation-costs/navigation-costs.component";
import { InputRadioComponent } from "./input-radio/input-radio.component";
import { FooterComponent } from "./footer/footer.component";
import { ButtonPrimaryComponent } from "./button-primary/button-primary.component";
import { ButtonSecondaryComponent } from "./button-secondary/button-secondary.component";
import { CardsComponent } from "./cards/cards.component";
import { CardComponent } from "./card/card.component";
import { InputTextComponent } from "./input-text/input-text.component";
import { InputNumberComponent } from "./input-number/input-number.component";
import { InputSelectComponent } from "./input-select/input-select.component";
import { InputRadioGroupComponent } from "./input-radio-group/input-radio-group.component";
import { InputCheckboxComponent } from "./input-checkbox/input-checkbox.component";
import { FrameIndicatorComponent } from "./frame-indicator/frame-indicator.component";

// Directives
import { SelectOnFocusDirective } from "./directives/select-on-focus.directive";
import { HasValueDirective } from "./directives/has-value.directive";

// Pipes
import { CurrencyPipe } from "./pipes/currency.pipe";
import { CurrencyComponent } from "./currency/currency.component";
import { ValidatorComponent } from "./validator/validator.component";
import { FeedbackComponent } from "./feedback/feedback.component";
import { FeedbackGroupComponent } from "./feedback-group/feedback-group.component";

@NgModule({
    imports: [

        //
        // Modules
        //
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        IconsModule,
    ],
    declarations: [

        //
        // Components
        //
        StepsComponent,
        StepComponent,
        NavigationComponent,
        NavigationCostsComponent,
        InputRadioComponent,
        FooterComponent,
        ButtonPrimaryComponent,
        ButtonSecondaryComponent,
        CardsComponent,
        CardComponent,
        InputTextComponent,
        InputNumberComponent,
        InputSelectComponent,
        InputRadioGroupComponent,
        InputCheckboxComponent,
        HasValueDirective,
        FrameIndicatorComponent,
        CurrencyComponent,
        ValidatorComponent,
        FeedbackComponent,
        FeedbackGroupComponent,

        //
        // Directives
        //
        SelectOnFocusDirective,

        //
        // Pipes
        //
        CurrencyPipe,

    ],
    exports: [

        //
        // Modules
        //
        CommonModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        IconsModule,

        //
        // Components
        //
        StepsComponent,
        StepComponent,
        NavigationComponent,
        NavigationCostsComponent,
        InputRadioComponent,
        FooterComponent,
        ButtonPrimaryComponent,
        ButtonSecondaryComponent,
        CardsComponent,
        CardComponent,
        InputTextComponent,
        InputNumberComponent,
        InputSelectComponent,
        InputRadioGroupComponent,
        InputCheckboxComponent,
        FrameIndicatorComponent,
        CurrencyComponent,
        ValidatorComponent,
        FeedbackComponent,
        FeedbackGroupComponent,

        //
        // Directives
        //
        SelectOnFocusDirective,
        HasValueDirective,

        //
        // Pipes
        //
        CurrencyPipe,

    ],
})
export class SharedModule { }
